import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const { login, register, isLoading, error } = useContext(AuthContext);
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({ email: '', password: '', firstName: '', lastName: '' });
  const [formError, setFormError] = useState('');

  const handleChange = (e) => setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    if (isLogin) {
      const ok = await login(formData.email, formData.password);
      if (ok) { onClose(); setFormData({ email: '', password: '', firstName: '', lastName: '' }); onLoginSuccess?.(); }
    } else {
      if (!formData.firstName?.trim() || !formData.lastName?.trim()) { setFormError('First name and last name required'); return; }
      const ok = await register(formData.email, formData.password, formData.firstName.trim(), formData.lastName.trim());
      if (ok) { onClose(); setFormData({ email: '', password: '', firstName: '', lastName: '' }); onLoginSuccess?.(); }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8 w-full max-w-md my-auto">
        <div className="flex justify-between items-center mb-4 sm:mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800">{isLogin ? 'Login' : 'Register'}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl min-w-[44px] min-h-[44px] flex items-center justify-center touch-manipulation -mr-2" aria-label="Close">×</button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">First Name</label><input type="text" name="firstName" value={formData.firstName} onChange={handleChange} className="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-base min-h-[44px] touch-manipulation" placeholder="John" /></div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label><input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-base min-h-[44px] touch-manipulation" placeholder="Doe" /></div>
            </>
          )}
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Email</label><input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-base min-h-[44px] touch-manipulation" placeholder="john@example.com" /></div>
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Password</label><input type="password" name="password" value={formData.password} onChange={handleChange} required className="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-base min-h-[44px] touch-manipulation" placeholder="••••••••" /></div>
          {(error || formError) && <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-lg text-sm">{error || formError}</div>}
          <button type="submit" disabled={isLoading} className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50 min-h-[44px] touch-manipulation">{isLoading ? 'Loading...' : isLogin ? 'Login' : 'Register'}</button>
        </form>
        <div className="mt-4 text-center">
          <button type="button" onClick={() => { setIsLogin(!isLogin); setFormError(''); setFormData({ email: '', password: '', firstName: '', lastName: '' }); }} className="text-blue-600 hover:text-blue-700 text-sm font-medium py-2 min-h-[44px] flex items-center justify-center mx-auto touch-manipulation">{isLogin ? "Don't have an account? Register" : 'Already have an account? Login'}</button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
